import { DEFAULT_CSS_CLASS } from '@constants';
import './editor.scss';

const {
  blockEditor: { useBlockProps, useInnerBlocksProps, useSetting },
  element: { useEffect },
} = wp;

const BLOCKS_TEMPLATE = [
  ['core/paragraph', { placeholder: 'Accordion Content' }],
];

const Edit = ({ name, context, setAttributes }) => {
  const { expandDefault, expandAll, uniqueID } = context;

  const defaultBlockCssClass = DEFAULT_CSS_CLASS.ACCORDION;
  const blockProps = useBlockProps({
    className: `${defaultBlockCssClass}__itm-bdy`,
  });

  useEffect(() => {
    setAttributes({ isExpanded: expandDefault || expandAll });
  }, [setAttributes, expandDefault, expandAll]);

  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    template:
      useSetting(`custom.blocks.${name}.blocksTemplate`) ?? BLOCKS_TEMPLATE,
    templateLock: false,
  });
  const inlineStyles = { display: 'none' };
  return (
    <div
      className={`${defaultBlockCssClass}__itm-bdy-wrpr`}
      id={uniqueID}
      style={inlineStyles}
    >
      <div {...innerBlocksProps} />
    </div>
  );
};

export default Edit;
